export const categories = [
  {
    "id": 1,
    "vi": "Động vật & thực vật",
    "en": "Animal & Plant",
    "tw": "動植物",
    "cn": "动植物",
    "img-pos": 0,
    "count": 9
  },
  {
    "id": 2,
    "vi": "Giải trí",
    "en": "Leisure",
    "tw": "休閒",
    "cn": "休闲",
    "img-pos": 1,
    "count": 7
  },
  {
    "id": 3,
    "vi": "Thiên văn học & Địa lý",
    "en": "Astronomy & Geography",
    "tw": "天文與地理",
    "cn": "天文与地理",
    "img-pos": 2,
    "count": 6
  },
  {
    "id": 4,
    "vi": "Sức khỏe",
    "en": "Health",
    "tw": "健康",
    "cn": "健康",
    "img-pos": 3,
    "count": 4
  },
  {
    "id": 5,
    "vi": "Thức ăn",
    "en": "Food",
    "tw": "餐飲",
    "cn": "餐饮",
    "img-pos": 4,
    "count": 4
  },
  {
    "id": 6,
    "vi": "Cuộc sống hàng ngày",
    "en": "Daily Life",
    "tw": "日常生活",
    "cn": "日常生活",
    "img-pos": 5,
    "count": 9
  },
  {
    "id": 7,
    "vi": "Giáo dục",
    "en": "Education",
    "tw": "教育",
    "cn": "教育",
    "img-pos": 6,
    "count": 4
  },
  {
    "id": 8,
    "vi": "Giao thông",
    "en": "Traffic",
    "tw": "交通",
    "cn": "交通",
    "img-pos": 7,
    "count": 3
  },
  {
    "id": 9,
    "vi": "Khác",
    "en": "etc",
    "tw": "其他",
    "cn": "其他",
    "img-pos": 8,
    "count": 10
  }
]